import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function ScholarshipList() {
  const [exams, setExams] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    loadExams();
  }, []);

  const loadExams = async () => {
    try {
      const res = await api.get("/student/mega-scholarship/list");
      setExams(Array.isArray(res.data) ? res.data : []);
    } catch {
      alert("Failed to load exams");
    }
  };

  const renderButton = (exam) => {
    if (!exam.is_registered) {
      return (
        <button
          onClick={() => nav(`/student/mega-scholarship/${exam.id}`)}
          style={btnPrimary}
        >
          Register & Pay
        </button>
      );
    }

    if (!exam.is_started) {
      return (
        <button disabled style={btnDisabled}>
          Scheduled
        </button>
      );
    }

    return (
      <button
        onClick={() => nav(`/student/mega-scholarship/${exam.id}/attempt`)}
        style={btnPrimary}
      >
        ▶ Start Exam
      </button>
    );
  };

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          {/* ================= HEADER ================= */}
          <div style={headerStyle}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />
            <h2 style={titleStyle}>🏆 Scholarship Exams</h2>
          </div>

          {/* ================= BACK ================= */}
          <button
            onClick={() => nav("/user/dashboard")}
            style={btnSecondary}
          >
            ← Back to Dashboard
          </button>

          {/* ================= LIST ================= */}
          {exams.length === 0 && (
            <p style={{ marginTop: 20 }}>No exams available</p>
          )}

          <div style={{ marginTop: 20 }}>
            {exams.map((exam) => (
              <div key={exam.id} style={examCard}>
                <h4 style={{ marginBottom: 6 }}>{exam.title}</h4>
                <p>📅 Date: {exam.exam_date}</p>
                <p>💰 Fee: ₹{exam.entry_fee}</p>
                <div style={{ marginTop: 10 }}>
                  {renderButton(exam)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ================= BACKGROUND ================= */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

/* ================= CARD ================= */
const cardStyle = {
  maxWidth: 900,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 30,
};

/* ================= HEADER ================= */
const headerStyle = {
  textAlign: "center",
  marginBottom: 20,
};

const logoStyle = {
  width: 120,
  marginBottom: 6,
};

const titleStyle = {
  fontSize: 20,
  fontWeight: 800,
};

/* ================= EXAM CARD ================= */
const examCard = {
  border: "1px solid #e5e7eb",
  padding: 16,
  borderRadius: 12,
  marginBottom: 14,
  background: "#fff",
};

/* ================= BUTTONS ================= */
const btnPrimary = {
  padding: "8px 16px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const btnSecondary = {
  padding: "8px 16px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  marginBottom: 20,
};

const btnDisabled = {
  padding: "8px 16px",
  background: "#cbd5e1",
  color: "#475569",
  border: "none",
  borderRadius: 8,
};
